import { render, staticRenderFns } from "./HistoryPolicy.vue?vue&type=template&id=189432cd&scoped=true&"
import script from "./HistoryPolicy.vue?vue&type=script&lang=js&"
export * from "./HistoryPolicy.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPolicy.vue?vue&type=style&index=0&id=189432cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189432cd",
  null
  
)

export default component.exports